const plugin = require('tailwindcss/plugin');

module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    gray: '#636363',
                    slidergray: '#dedede',
                    darkblue: '#005BA2',
                    lightblue: '#30B5EF',
                    footerblue: '#005291',
                    orange: '#FF8431',
                },
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    variants: {
        textColor: ({ after }) => after(['invalid']),
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/forms'),
        plugin(function ({ addVariant, e }) {
            addVariant('invalid', ({ modifySelectors, separator }) => {
                modifySelectors(({ className }) => {
                    return `.${e(`invalid${separator}${className}`)}:invalid`;
                });
            });
        }),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
